import { useState } from 'react';
import Plans from './Plans';
import Topups from './Topups';

export default function ManagePlans() {
  const [tab, setTab] = useState(0);
  const [showAdd, setShowAdd] = useState(false);

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16 }}>
        <div className="seg">
          <label className="seg-opt">
            <input type="radio" name="ptab" checked={tab === 0} onChange={() => setTab(0)} />
            Subscriptions
          </label>
          <label className="seg-opt">
            <input type="radio" name="ptab" checked={tab === 1} onChange={() => setTab(1)} />
            Topups
          </label>
        </div>
        <div style={{ flex: 1 }}></div>
        <button className="btn btn-primary" onClick={() => setShowAdd(true)}>
          <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M5 12h14" /><path d="M12 5v14" /></svg>
          {tab === 0 ? 'Add Plan' : 'Add Topup'}
        </button>
      </div>
      {tab === 0
        ? <Plans showAdd={showAdd} setShowAdd={setShowAdd} />
        : <Topups showAdd={showAdd} setShowAdd={setShowAdd} />}
    </div>
  );
}
